import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { eramanCMSApi, post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "../constants";
import { useOutletDocumentDetails } from "./hooks/Outlet.hook";

export const FAndBAddEditOutlet = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [formConfig, setFormConfig] = useState<FormConfig | null>(null);
  const [records, setRecords] = useState<any[]>([]);
  const [isLoadingRecords, setIsLoadingRecords] = useState(false);

  const {
    data: editOutlet,
    isLoading: drilldownLoading,
    refetch: refetchBrands,
  } = useOutletDocumentDetails(query.get("editId") || "");

  const {
    data: editOutletById,
    isLoading: isLoadingBrands,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");
  const getRecords = () => {
    setIsLoadingRecords(true);
    let url = `/api/all-food-and-beverages-data-list`;
    eramanCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data.data;
          setRecords(envelopes);
        }
        setIsLoadingRecords(false);
      })
      .catch(() => {
        setRecords([]);
        setIsLoadingRecords(false);
      });
  };
  useEffect(() => {
    getRecords();
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchBrands();
    }
  }, [query.get("editId"), query.get("id")]);

  const Config: FormConfig = {
    initialValues: {
      field_common_image: editOutletById?.payload?.field_common_image
        ? [
            {
              uid: "-1",
              name: "outletImage.png",
              status: "done",
              url: editOutletById?.payload?.field_common_image,
            },
          ]
        : [
            {
              uid: "-1",
              name: "outletImage.png",
              status: "done",
              url: editOutlet?.field_common_image,
            },
          ],
      title: editOutletById?.payload?.title ?? editOutlet?.title,
      field_common_malay_title:
        editOutletById?.payload?.field_common_malay_title ?? editOutlet?.field_common_malay_title,
      field_common_mandarin_title:
        editOutletById?.payload?.field_common_mandarin_title ?? editOutlet?.field_common_mandarin_title,
      field_food_bev_airport: editOutletById?.payload?.field_food_bev_airport ?? editOutlet?.field_food_bev_airport,
      field_food_and_beverage_types:
        editOutletById?.payload?.field_food_and_beverage_types ?? editOutlet?.field_food_and_beverage_types,
      field_store_location: editOutletById?.payload?.field_store_location ?? editOutlet?.field_store_location,
      field_brands: editOutletById?.payload?.field_brands ?? editOutlet?.field_brands,
      body: editOutletById?.payload?.body ? decodeHTML(editOutletById?.payload?.body) : decodeHTML(editOutlet?.body),
      field_common_malay_description: editOutletById?.payload?.field_common_malay_description
        ? decodeHTML(editOutletById?.payload?.field_common_malay_description)
        : decodeHTML(editOutlet?.field_common_malay_description),
      field_common_mandarin_descriptio: editOutletById?.payload?.field_common_mandarin_descriptio
        ? decodeHTML(editOutletById?.payload?.field_common_mandarin_descriptio)
        : decodeHTML(editOutlet?.field_common_mandarin_descriptio),
      published: editOutletById?.payload?.published
        ? decodeHTML(editOutletById?.payload?.published)
        : decodeHTML(editOutlet?.published),
    },
    fields: fields.fAndBOutlet.map((field: any) =>
      field.name === "field_food_bev_airport"
        ? {
            ...field,
            validation: {
              required: "Airport is required",
              validate: (value: string, formValues: FieldValues) => {
                if (!formValues.field_food_and_beverage_types) return true;
                const existingRecord = records.find(
                  (record) =>
                    decodeHTML(record.field_food_and_beverage_types) ===
                      decodeHTML(formValues.field_food_and_beverage_types) &&
                    decodeHTML(record.field_food_bev_airport) === decodeHTML(value) &&
                    record.id !== (editOutletById?.payload?.id || editOutlet?.id)
                );
                return !existingRecord || "Airport already exists for the selected food and beverage type";
              },
            },
          }
        : field
    ),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);
    let imageKeys: any = ["field_common_image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Product Management",
      subModule: "fAndBOutlet",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editOutletById?.payload?.id || editOutlet?.id }),
        ...data,
        // status: true,
      },
      status: status,
    };

    // Log the complete payload
    console.log("Final Payload:", payload);

    // Commented out API calls for testing
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Outlet`}
      showBack
    >
      <DynamicForm
        isLoading={drilldownLoading}
        config={Config}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") ? `${eramanHost}/api/food-and-beverages-data-list-page-crud-api/${editOutletById?.payload?.id || editOutlet?.id}` : `${eramanHost}/api/create/food-and-beverages-data-list-page-crud-api`}`,
            `${query.get("editId") ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
